const SOCIAL_CATEGORY_KEYS: Record<string, string> = {
  disability_1: "socialCategories.disability_1",
  disability_2: "socialCategories.disability_2",
  disability_3: "socialCategories.disability_3",
  child_disability: "socialCategories.child_disability",
  veteran: "socialCategories.veteran",
  orphan: "socialCategories.orphan",
  large_family: "socialCategories.large_family",
  single_parent_family: "socialCategories.single_parent_family",
  retired: "socialCategories.retired",
  kandas: "socialCategories.kandas",
};

export function getSocialCategoryLabel(categoryType: string, t: (key: string) => string): string {
  const key = SOCIAL_CATEGORY_KEYS[categoryType];
  if (key) return t(key);
  return categoryType;
}
